import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./toast.scss";

/*
 * 🔴 `toast.configure()` USED TO BE CALLED HERE, AFTER EVERY TOAST.
 *
 * Symptom, found live 2026-08-10 while testing the credit-purchase flow:
 * toastMessageError() was genuinely called with the right message - proven
 * with a temporary diagnostic log - and NO toast element ever appeared in the
 * DOM. Every error in the app failed silently, across 32 call sites.
 *
 * Cause: in react-toastify v8 `configure()` is a legacy v5/v6 API whose whole
 * job is to set the LAZY-CONTAINER flag (`H = true` in the minified source),
 * so the library injects a container of its own into document.body. But
 * App.tsx already renders an explicit <ToastContainer />. That left two
 * containers competing, and it was invoked AFTER the toast had already been
 * emitted, and again on every single call rather than once at startup.
 *
 * The supported v8 pattern is exactly one explicit <ToastContainer /> mounted
 * in the tree, which App.tsx has. So configure() is simply removed - there is
 * nothing to replace it with.
 */

// Shared options, so success and error cannot drift apart. autoClose differs
// deliberately: an error should stay long enough to read and act on.
const BASE: ToastOptions = {
  position: "top-right",
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const toastMessageSuccess = (message: string, toastId?: string) => {
  toast.success(message, { ...BASE, autoClose: 5000, toastId });
};

export const toastMessageError = (message: string, toastId?: string) => {
  toast.error(message, { ...BASE, autoClose: 8000, toastId });
};
